import { globalUrlHelper } from 'src/utils/common';

import { TNCLink, TNCStyle } from './styles';

const TNC = () => {
  const tocText = 'See our {{TOC}} for more details.';
  const tocLinkText = 'Terms of use';
  const splitText = tocText.split('{{TOC}}');
  return (
    <TNCStyle data-test-id="tnc-container">
      {splitText[0]}
      <TNCLink data-test-id="tnc-link" href={globalUrlHelper('/termsofuse')}>
        {tocLinkText}
      </TNCLink>
      {splitText?.[1] || ''}
    </TNCStyle>
  );
};
export default TNC;
